import { useMemo, useCallback } from "react";
import { Pollutant } from "@/types/pollutant/pollutant.types";
import { FilterOption } from "@/components/ui/table-header/types";

interface UsePollutantFiltersProps {
    pollutants: Pollutant[];
    searchTerm: string;
    nameFilters: string[];
}

export const usePollutantFilters = ({
    pollutants,
    searchTerm,
    nameFilters,
}: UsePollutantFiltersProps) => {
    const filteredPollutants = useMemo(() => {
        if (!pollutants || pollutants.length === 0) return [];

        return pollutants.filter((pollutant) => {
            // Filter by search term
            if (searchTerm && !pollutant.name?.toLowerCase().includes(searchTerm.toLowerCase())) {
                return false;
            }

            // Filter by name filters
            if (nameFilters.length > 0 && !nameFilters.includes(pollutant.name)) {
                return false;
            }

            return true;
        });
    }, [pollutants, searchTerm, nameFilters]);

    const getUniqueOptions = useCallback(
        (field: keyof Pollutant): FilterOption[] => {
            if (!pollutants || pollutants.length === 0) return [];

            const uniqueValues = new Set<string>();

            pollutants.forEach((pollutant) => {
                if (field === "name" && pollutant.name) {
                    uniqueValues.add(pollutant.name);
                }
            });

            return Array.from(uniqueValues)
                .sort()
                .map((value) => ({
                    label: value,
                    value: value,
                }));
        },
        [pollutants]
    );

    return {
        filteredPollutants,
        getUniqueOptions,
    };
}; 